module.exports = __webpack_public_path__ + "static/media/352JamesPBrawleyDrNW_2018-06-11_71.1c86e6e0.jpg";